import {Component, ElementRef, HostListener, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'lib-screen-ipad',
    templateUrl: './screen-ipad.component.html',
    styleUrls: ['./screen-ipad.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScreenIpadComponent implements OnInit {

  @Input() url;
  @Input() point;
  @Input() imageSize;
  widthPhoto = 100;
  heightPhoto = 100;
  leftPhoto = 235;
  topPhoto = 39;

  @HostListener('window:resize') resize() {
    this.calc();
  }

  constructor(private ipad: ElementRef<HTMLElement>) {
  }

  ngOnInit() {
    this.calc();
  }

  calc() {
    const {height, width} = this.ipad.nativeElement.getBoundingClientRect();
    console.log('wysokość kontenera', height, 'szerokość kontenera', width);
    if (height > width / 1.98) {
      this.widthPhoto = width * .3;
      this.heightPhoto = width / 1.98 * .8;
    }
    if (height <= width / 1.98) {
      this.heightPhoto = height * .8;
      this.widthPhoto = height * 1.98 * .3;
    }

    this.topPhoto = (height - this.heightPhoto) / 2;
    this.leftPhoto = (width - this.widthPhoto) / 2;
    console.log('wysokość zdjecia', this.heightPhoto, 'szerokość zdjecia', this.widthPhoto);
    console.log('top zdjecia', this.topPhoto, 'left zdjecia', this.leftPhoto);
  }
}
